export default "__VITE_ASSET__Dsv0Yi8x__"